import styled from '@emotion/styled'
import { Grid } from "@mui/material";
import { Colors } from '../../../colors';
import { mediaQueryMobileLimit } from '../../../utils/constants';

export const BookingPageStyled = {
  Container: styled(Grid)<any>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: ${Colors.PrimaryBackground};
    width: 100%;
    @media (min-width: ${mediaQueryMobileLimit}px) {
      padding: 34px;
    }
  `
};



